import { APPLICATION_STATUS } from 'config/constants'

const STATUS_LABEL_KEYS: Record<APPLICATION_STATUS, string> = {
  [APPLICATION_STATUS.PREPARING]: 'applications__status__preparing',
  [APPLICATION_STATUS.AWAITING_CLIENT]: 'applications__status__awaitingClient',
  [APPLICATION_STATUS.PREPARATION_COMPLETE]: 'applications__status__preparationComplete',
  [APPLICATION_STATUS.AWAITING_EXECUTOR_PROPOSAL]: 'applications__status__awaitingProposal',
  [APPLICATION_STATUS.PROPOSAL_READY]: 'applications__status__proposalReady',
  [APPLICATION_STATUS.AWAITING_EXECUTOR_CONTACT]: 'applications__status__awaitingContact',
  [APPLICATION_STATUS.AT_EXECUTOR]: 'applications__status__atExecutor',
  [APPLICATION_STATUS.CLOSED]: 'applications__status__closed',
}

export const getApplicationStatusLabel = ({ status, fallback, translate }: ApplicationStatusLabelArgs) => {
  const key = STATUS_LABEL_KEYS[status as APPLICATION_STATUS]

  return key ? translate(key) : fallback
}
